module.exports = __webpack_public_path__ + "static/media/jad-blaik.461d633d.md";